export type NotificationStatus = 'all' | 'unread' | 'read'
export type NotificationChannel = 'database' | 'broadcast' | 'mail' | 'webpush'

export interface AppNotification {
  id: string
  event_key: string
  title: string
  body: string
  url: string | null
  meta: Record<string, unknown>
  read_at: string | null
  created_at: string
}

export interface LaravelPaginationLink {
  url: string | null
  label: string
  active: boolean
}

export interface LaravelResourcePage<T> {
  data: T[]
  links: {
    first: string | null
    last: string | null
    prev: string | null
    next: string | null
  }
  meta: {
    current_page: number
    from: number | null
    last_page: number
    links: LaravelPaginationLink[]
    path: string
    per_page: number
    to: number | null
    total: number
  }
}

export interface NotificationListParams {
  page?: number
  per_page?: number
  status?: NotificationStatus
  event_key?: string
}

export interface NotificationPreferenceRow {
  event_key: string
  channel: NotificationChannel
  enabled: boolean
  default_enabled: boolean
  available: boolean
}

export interface NotificationPreferenceChannel {
  channel: NotificationChannel
  enabled: boolean
  default_enabled: boolean
  available: boolean
}

export interface NotificationPreferenceEvent {
  event_key: string
  channels: NotificationPreferenceChannel[]
}

export interface NotificationPreferences {
  preferences: NotificationPreferenceRow[]
  settings: {
    lesson_start_before_minutes: number
    chat_email_digest_minutes: number
  }
}

export interface NotificationPreferencesPatch {
  preferences: Array<{
    event_key: string
    channel: NotificationChannel
    enabled: boolean
  }>
  lesson_start_before_minutes: number
  chat_email_digest_minutes: number
}

export interface PushSubscriptionResource {
  id: number
  endpoint: string
  created_at: string
}

export function groupNotificationPreferences(
  preferences: NotificationPreferenceRow[],
): NotificationPreferenceEvent[] {
  const byEvent = new Map<string, NotificationPreferenceEvent>()
  for (const row of preferences) {
    const existing = byEvent.get(row.event_key)
    const channel: NotificationPreferenceChannel = {
      channel: row.channel,
      enabled: row.enabled,
      default_enabled: row.default_enabled,
      available: row.available,
    }
    if (!existing) {
      byEvent.set(row.event_key, { event_key: row.event_key, channels: [channel] })
      continue
    }
    existing.channels.push(channel)
  }
  return [...byEvent.values()]
}
